import { debounce, fetchConfig } from "./global";

class CartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("click", (event) => {
			event.preventDefault();
			this.closest("cart-items").updateQuantity(this.dataset.index, 0);
		});
	}
}

customElements.get("cart-remove-button") ||
	customElements.define("cart-remove-button", CartRemoveButton); // eslint-disable-line

class CartItems extends HTMLElement {
	constructor() {
		super();

		this.lineItemStatusElement = document.getElementById(
			"shopping-cart-line-item-status",
		);

		this.debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, 300);

		this.addEventListener("change", this.debouncedOnChange.bind(this));
	}

	onChange(event) {
		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute("name"),
		);
	}

	getSectionsToRender() {
		return [
			{
				id: "main-cart-items",
				section: document.getElementById("main-cart-items").dataset.id,
				selector: ".js-contents",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section",
			},
			{
				id: "main-cart-footer",
				section: document.getElementById("main-cart-footer").dataset.id,
				selector: ".js-contents",
			},
		];
	}

	updateQuantity(line, quantity, name) {
		this.enableLoading(line);
		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => response.text())
			.then((state) => {
				const parsedState = JSON.parse(state);
				this.classList.toggle("is-empty", parsedState.item_count === 0);
				document
					.getElementById("main-cart-footer")
					.classList.toggle("is-empty", parsedState.item_count === 0);

				this.getSectionsToRender().forEach((section) => {
					/* eslint-disable max-len */
					const elementToReplace =
						document
							.getElementById(section.id)
							.querySelector(section.selector) ||
						document.getElementById(section.id);

					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector,
					);
					/* eslint-enable max-len */
				});

				this.updateLiveRegions();
				this.updateCartItemErrorMessage(line);
				document
					.getElementById(`CartItem-${line}`)
					.querySelector(`[name="${name}"]`)
					.focus();
				this.disableLoading();
			})
			.catch(() => {
				this.updateCartItemErrorMessage(line);
				this.querySelectorAll(".loading-overlay").forEach((overlay) => {
					overlay.classList.add("hidden");
				});
				document.getElementById("cart-errors").textContent =
					window.cartStrings.error;
				this.disableLoading();
			});
	}

	updateCartItemErrorMessage(line) {
		const targetCartItem = this.querySelector(`#CartItem-${line}`);
		const targetCartItemQtyInput = this.querySelector(
			`#CartItem-${line} input.quantity__input`,
		);
		const cartItemInventoryQuantity = Number(
			targetCartItem?.dataset?.inventoryQuantity,
		);
		const cartItemQtyCurrent = Number(targetCartItemQtyInput.value);

		if (
			cartItemInventoryQuantity > 0 &&
			cartItemInventoryQuantity <= cartItemQtyCurrent
		) {
			// error qty
			targetCartItemQtyInput.value = cartItemInventoryQuantity;
			const cartItemErrorElement = this.querySelector(
				`#Line-item-error-${line}`,
			);
			if (cartItemErrorElement) {
				cartItemErrorElement.style.display = "flex";
				const cartItemErrorTextElement = cartItemErrorElement.querySelector(
					".cart-item__error-text",
				);
				if (cartItemErrorTextElement) {
					cartItemErrorTextElement.innerHTML =
						window.cartStrings.quantityError.replace(
							"[quantity]",
							cartItemInventoryQuantity,
						);
				}
			}
		}
	}

	updateLiveRegions() {
		this.lineItemStatusElement.setAttribute("aria-hidden", true);

		const cartStatus = document.getElementById("cart-live-region-text");
		cartStatus.setAttribute("aria-hidden", false);

		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		document
			.getElementById("main-cart-items")
			.classList.add("cart__items--disabled");
		this.querySelectorAll(".loading-overlay")[line - 1].classList.remove(
			"hidden",
		);
		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}

	disableLoading() {
		document
			.getElementById("main-cart-items")
			.classList.remove("cart__items--disabled");
	}
}

customElements.get("cart-items") ||
	customElements.define("cart-items", CartItems); // eslint-disable-line
